const namedAlphabets = [
  'Arabic',
  'Han',
  'Hiragana',
  'Hangul',
  'Katakana',
  'Cyrillic',
  'Thai',
];
const additionalClasses = [
  'A-Za-zŽžÀ-ÿ',
  'ığüşöçĞÜŞÖÇİ',
  '0-9',
  '-',
  '_',
  ' ',
  '?',
  '¿',
];

export const REGEX_MULTILINGUAL = new RegExp(
  `[^${[
    ...namedAlphabets.map(a => `\\p{Script=${a}}`),
    `${additionalClasses.join('')}`,
  ].join('')}]`,
  'ug',
);
